/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

import { Flex } from "../shared";

const Controller = styled.div(
  {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "3rem",
    borderRadius: "50%",
    borderWidth: "2px",
    borderStyle: "solid",
    width: "4rem",
    height: "4rem",
    cursor: "pointer",
    position: "relative",

    "&:before": {
      content: `""`,
      borderStyle: "solid",
      borderWidth: "2px 2px 0 0",
      transform: "rotate(-135deg) translate(-50%, 50%)",
      position: "absolute",
      right: "50%",
      width: "30%",
      height: "30%",
    },
  },
  (props) => ({
    borderColor: props.disable ? "#D1FAD7" : "#50976A",
    color: props.disable ? "#50976A" : "#ffffff",
    backgroundColor: props.disable ? "transparent" : "#50976A",
  })
);

const Indicator = ({ scrollLeft, scrollRight, styles, isLeft, isRight }) => {
  return (
    <Flex css={{ ...styles }}>
      <Controller
        css={{ marginRight: "2rem" }}
        disable={isLeft}
        onClick={scrollLeft}
      ></Controller>
      <Controller
        css={{ transform: "rotate(180deg)" }}
        onClick={scrollRight}
        disable={isRight}
      ></Controller>
    </Flex>
  );
};

export default Indicator;
